import { useLoaderData } from "react-router-dom";

import Locations from "../../../../../entityLocations";

export default function EntityLocations() {
  const { id } = useLoaderData();
  return (
    <div
      className="flex h-full w-full flex-col gap-3 overflow-y-auto rounded-[14px] bg-white p-6"
    >
      <Locations entityId={id} />
    </div>
  );
}
